// @flow weak
/*
Wrap a component so that when it gets mounted or props change, it runs a static
method `runActions` attached to the component class. This is pretty brute force
since it passes the entire store to `runActions`. This should be made more
functional by just getting the actions to be dispatched instead.

If `runActions` returns a promise, it will set a `isRunningActions` prop to
true and then to false when the promise resolves.
*/

import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class'; // eslint-disable-line no-restricted-syntax
import shallowEqual from 'shallowequal';

import { isPromise } from 'app/common/CommonUtils';
import { makeWrappedDisplayName } from 'app/common/utils/ReactUtils';

const runActions = Component => {
  const RunActions = createReactClass({
    displayName: makeWrappedDisplayName('RunActions', Component),
    ignoreRunActionsResult: (null: ?boolean),

    contextTypes: {
      store: PropTypes.object,
    },

    getInitialState() {
      return {
        isRunningActions: false,
        hasRunActions: false,
      };
    },

    runActions(props, prevProps) {
      if (Component.runActions) {
        if (
          Component.shouldRunActions &&
          !Component.shouldRunActions(props, prevProps, this.state)
        ) {
          this.setState({ isRunningActions: false });
          return;
        }

        this.setState({
          isRunningActions: true,
          hasRunActions: true,
        });

        const { context } = this;
        const { store } = context;

        const result = Component.runActions(store, props);

        if (!isPromise(result)) {
          // If we don't have a promise, then there's nothing to wait on, so consider things ready.
          this.setState({
            isRunningActions: false,
          });
        } else {
          result.then(() => {
            if (!this.ignoreRunActionsResult) {
              this.setState({
                isRunningActions: false,
              });
            }
          });
        }
      } else {
        this.setState({ isRunningActions: false });
      }
    },

    UNSAFE_componentWillMount() {
      this.runActions(this.props);
    },

    componentWillUnmount() {
      this.ignoreRunActionsResult = true;
    },

    UNSAFE_componentWillReceiveProps(nextProps) {
      if (!shallowEqual(nextProps, this.props)) {
        this.runActions(nextProps, this.props);
      }
    },

    render() {
      return <Component {...this.props} {...this.state} />;
    },
  });

  return RunActions;
};

export default runActions;
